import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { alertaGeneral } from "../../utils/alertas";
import apiClient from "../../utils/axiosPetition";

const PagRespuestaCursoEpayco = () => {
    const [searchParams] = useSearchParams();
    const refPayco = searchParams.get('ref_payco');
    const cursoId = searchParams.get('cursoId') || localStorage.getItem('cursoId');
    const [estado, setEstado] = useState(null);
    const navigate = useNavigate();

    const onApproved = (referenceCode) => {
        const doctorId = localStorage.getItem('doctorId');
        const dataToSend = {
            doctorId,
            referenceCode
        }
        if (!cursoId) {
            alertaGeneral({
                titulo: 'Error',
                messageHtml: 'No se pudo identificar el curso para registrar el pago.',
                isError: true
            });
            return navigate("/doctor");
        }
        apiClient.post(`/api/cursos/registrarPagoCurso/${cursoId}`, dataToSend)
            .then(res => {
                localStorage.removeItem('cursoId');
                navigate("/doctor");
            })
            .catch(error => {
                alertaGeneral({
                    titulo: 'Error',
                    messageHtml: error.response?.data?.message || 'Ocurrió un error al registrar el pago del curso',
                    isError: true
                });
                navigate("/doctor");
            });
    };

    useEffect(() => {
        if (refPayco) {
            fetch(`https://secure.epayco.co/validation/v1/reference/${refPayco}`)
                .then(res => res.json())
                .then(data => {
                    setEstado(data.data.x_response); // "Aceptada", "Rechazada", etc.
                    const referenceCode = data.data.x_id_invoice || data.data.x_id_factura;
                    if (data.data.x_response === "Aceptada") {
            alertaGeneral({
                titulo: 'Transacción aprobada',
                messageHtml: 'Su inscripción al curso ha sido exitosa',
            });
                        onApproved(referenceCode);
                    } else if (data.data.x_response) {
            alertaGeneral({
                titulo: 'Error',
                            messageHtml: `La transacción no fue aprobada. Estado: ${data.data.x_response}`,
                isError: true
            });
                        navigate("/doctor");
                    }
                });
        }
    }, [refPayco]);

    if (!estado) {
        return <div className="flex flex-col items-center justify-center min-h-[200px]">Consultando estado del pago...</div>;
    }
    return null;
}

export default PagRespuestaCursoEpayco; 